// extracted by mini-css-extract-plugin
export default {"video":"Video_video__RSVWa","qmeta":"Video_qmeta__2vOyk"};